import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../styles/theme'

const useStyles = makeStyles((theme) => ({
    label: {
        padding: '0px',
        width: '100%',
        textAlign: 'center',
    },
    chipDefault: {
        color: themeCommon.lightBlue,
        border: `1px solid ${themeCommon.lightBlue}`,
        background: '#FFFFFF',
        minWidth: '106px',
        width: 'fit-content',
        height: '40px',
        borderRadius: '20px',
        fontFamily: themeCommon.RobotoBold,
        justifyContent: 'unset',
        // '& $avatar': {
        //     color: themeCommon.lightBlue,
        //     border: `2px solid ${themeCommon.lightBlue}`,
        //     fontSize: themeCommon.fontSize10px,
        //     width: '20px',
        //     height: '20px',
        //     fontFamily: '950',
        //     marginRight: '0',
        //     marginLeft: '10px',
        // },
    },
    iconPlus: {
        color: themeCommon.lightBlue,
        border: `1px solid ${themeCommon.lightBlue}`,
    },
    iconSubstract: {
        color: '#DA2A1C',
        border: `1px solid #DA2A1C`,
    },
    iconNonBorder: {
        border: 'unset',
    },
    btnTakeAssessment: {
        position: 'absolute',
        left: '50%',
        bottom: '0px',
        transform: 'translate(-50%, 50%)',
        cursor: 'pointer',
    },
    chipSizeBig: {
        minWidth: '106px',
        width: 'fit-content',
        height: '40px',
        padding: '0 7px',
        fontSize: themeCommon.fontSize20px,
    },
    chipSizeMedium: {
        minWidth: '75px',
        width: 'fit-content',
        height: '30px',
        padding: '0 5px',
        fontSize: themeCommon.fontSize14px,
    },
    chipSizeSmall: {
        minWidth: '50px',
        width: 'fit-content',
        height: '20px',
        padding: '0 5px',
        fontSize: themeCommon.fontSize10px,
    },
    colorDefaultAvatar: {
        backgroundColor: '#FFFFFF',
    },
    avatarDefault: {
        '& > img': {
            maxWidth: '100%',
        }
    },
    avatarBig: {
        //required
    },
    avatarMedium: {
        //required
    },
    avatarSmall: {
        //required
    },

    rootChip: {
        '& $avatarBig': {
            width: '24px',
            height: '24px',
            marginRight: '5px',
            marginLeft: '0',
        },
        '& $avatarMedium': {
            width: '18px',
            height: '18px',
            marginRight: '5px',
            marginLeft: '0',
        },
        '& $avatarSmall': {
            width: '12px',
            height: '12px',
            marginRight: '3px',
            marginLeft: '0',
        }
    }
}),
    {
        name: 'CoinHeadContainer',
        index: 1,
    }
)

export default useStyles